import React from 'react';
import imageUrlBuilder from '@sanity/image-url';
import { Card } from '@tmap/mmm-style-guide/src/Card';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { styled } from '@tmap/mmm-style-guide/src/styled';

import client from '../../client';

const builder = imageUrlBuilder(client);

const FACTOID_IMG_URL = 'https://cdn.sanity.io/images/u721u3r1/production/44bfd1dfb91fd039b4b8781901dcff4e0c10378a-88x132.png';

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: '8px',
  padding: '28px',
  border: `1px solid ${theme.palette.grey[300]}`,
}));

function CommunityFactoid(props) {
  const { locationName, factoid } = props;
  return (
    <StyledCard elevation={0} sx={{ padding: '28px', borderRadius: '8px' }}>
      <img
        height={66}
        width={44}
        alt=''
        src={builder.image(FACTOID_IMG_URL).url()}
      />
      <Typography variant='body2' color='info.dark' sx={{ marginTop: 1.5, textTransform: 'uppercase' }}>{locationName}: FUN FACT</Typography>
      <Typography variant='body2' color='text.secondary' sx={{ marginTop: '14px' }}>{factoid}</Typography>
    </StyledCard>
  );
}

export default CommunityFactoid;
